import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Calendar, Heart, MapPin, Settings } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const Navigation: React.FC = () => {
  const { t } = useTranslation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-surface border-t border-gray-800 pb-safe z-50">
      <div className="flex justify-around items-center p-2">
        <NavLink 
          to="/" 
          className={({ isActive }) => `flex flex-col items-center p-2 rounded-lg ${isActive ? 'text-primary' : 'text-gray-400'}`}
        >
          <Home className="w-6 h-6 mb-1" />
          <span className="text-xs">{t('nav.home')}</span>
        </NavLink>
        <NavLink 
          to="/lineup" 
          className={({ isActive }) => `flex flex-col items-center p-2 rounded-lg ${isActive ? 'text-primary' : 'text-gray-400'}`}
        >
          <Calendar className="w-6 h-6 mb-1" />
          <span className="text-xs">{t('nav.lineup')}</span>
        </NavLink>
        <NavLink 
          to="/favorites" 
          className={({ isActive }) => `flex flex-col items-center p-2 rounded-lg ${isActive ? 'text-primary' : 'text-gray-400'}`}
        >
          <Heart className="w-6 h-6 mb-1" />
          <span className="text-xs">{t('nav.favorites')}</span>
        </NavLink>
        <NavLink 
          to="/map" 
          className={({ isActive }) => `flex flex-col items-center p-2 rounded-lg ${isActive ? 'text-primary' : 'text-gray-400'}`}
        >
          <MapPin className="w-6 h-6 mb-1" />
          <span className="text-xs">{t('nav.map')}</span>
        </NavLink>
        <NavLink 
          to="/settings" 
          className={({ isActive }) => `flex flex-col items-center p-2 rounded-lg ${isActive ? 'text-primary' : 'text-gray-400'}`}
        >
          <Settings className="w-6 h-6 mb-1" />
          <span className="text-xs">{t('nav.settings')}</span>
        </NavLink>
      </div>
    </nav>
  );
};
